import React from 'react'

import {t} from '@lib/helpers'

const ICONS = [
  <img
    key='0'
    src='/images/landing/Business__icon--database.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='1'
    src='/images/landing/Business__icon--suitcase.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='2'
    src='/images/landing/Business__icon--shield.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='3'
    src='/images/landing/Business__icon--rocket.svg'
    alt=''
    width='24'
    height='24'
  />,
]

const Business = () => {
  const features = t('pages.index.landing.business.features') || []

  return (
    <section className='Landing__business'>
      <div className='container'>
        <div className='Landing__business__top'>
          <div className='Landing__business__left'>
            <span className='Landing__business__label'>
              {t('pages.index.landing.business.label')}
            </span>
            <h2 className='Landing__business__h2'>
              {t('pages.index.landing.business.h2')}
            </h2>
            <p className='Landing__business__p'>
              {t('pages.index.landing.business.p')}
            </p>
          </div>
          <div className='Landing__business__right'>
            <img
              src='/images/Landing_2.png'
              alt='Business Understanding Meets AI Execution'
              loading='lazy'
            />
          </div>
        </div>
        <div className='Landing__business__bottom'>
          {Array.isArray(features) &&
            features.map((feature, i) => (
              <div className='Landing__business__card' key={feature.title}>
                <div className='Landing__business__card__icon'>{ICONS[i]}</div>
                <h4 className='Landing__business__card__title'>
                  {feature.title}
                </h4>
                <p className='Landing__business__card__desc'>
                  {feature.description}
                </p>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Business
